import React from 'react';
import { cuisineIcon } from '../data/cuisines';
import './CuisineFilter.css';

// Tappable cuisines, multi-select. This exists so nobody has to spell
// "Vietnamese" to find Vietnamese food — the search box still works, but it
// only ever fired on a correct spelling.
//
// Counts are shown inline so a filter that would empty the list is visible
// before it's tapped.
export default function CuisineFilter({ facets, selected, onToggle, onClear, total }) {
  if (!facets.length) return null;

  return (
    <div className="cuisine-filter">
      <div
        className="cuisine-filter__rail"
        role="group"
        aria-label="Filter by venue type"
      >
        <button
          type="button"
          className="cuisine-filter__chip"
          aria-pressed={selected.size === 0}
          onClick={onClear}
        >
          <span className="cuisine-filter__icon" aria-hidden="true">&#127864;</span>
          All <span className="cuisine-filter__count">{total}</span>
        </button>

        {facets.map(({ label, count }) => (
          <button
            key={label}
            type="button"
            className="cuisine-filter__chip"
            aria-pressed={selected.has(label)}
            onClick={() => onToggle(label)}
          >
            {/* Decorative: the cuisine is already named right beside it, so a
                screen reader announcing "pizza pizza 3" would be noise. */}
            <span className="cuisine-filter__icon" aria-hidden="true">{cuisineIcon(label)}</span>
            {label} <span className="cuisine-filter__count">{count}</span>
          </button>
        ))}
      </div>

      {selected.size > 0 && (
        <button type="button" className="cuisine-filter__clear" onClick={onClear}>
          Clear {selected.size} filter{selected.size > 1 ? 's' : ''}
        </button>
      )}
    </div>
  );
}
